import {
    SYSTEM_GET_USERTAG_LIST_BEGIN,
    SYSTEM_GET_USERTAG_LIST_SUCCESS,
    SYSTEM_GET_USERTAG_LIST_FAILURE,
    SYSTEM_GET_USERTAG_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getUserTagList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_GET_USERTAG_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'get',
            url:'/v2/admin/user/tag/list',
            data:params,
          }).then( data => {
              dispatch({
                  type: SYSTEM_GET_USERTAG_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: SYSTEM_GET_USERTAG_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetUserTagListError() {
    return {
      type: SYSTEM_GET_USERTAG_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_GET_USERTAG_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getUserTagListPending: true,
          getUserTagListError: null,
        };
  
      case SYSTEM_GET_USERTAG_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          userTagById:byId,
          userTagList:items,
          userTagPage: action.data.page,
          userTagSize: action.data.size,
          userTagTotal: action.data.count,
          getUserTagListPending: false,
          getUserTagListError: null,
        };
  
      case SYSTEM_GET_USERTAG_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getUserTagListPending: false,
          getUserTagListError: action.data.error,
        };
  
      case SYSTEM_GET_USERTAG_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getUserTagListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/system/redux/getUserTagList.js